export const UPDATE_FURNITURE_MENU_ITEM_DRAG_ID = 'UPDATE_FURNITURE_MENU_ITEM_DRAG_ID'

export function updateFurnitureDragId (id) {
  return {
    type: UPDATE_FURNITURE_MENU_ITEM_DRAG_ID,
    id: id,
  }
}